<template>
  <div class="container-fluid">
    <div id="topo" class="card-header">
    <div class="row">
      <div class="col col-xs-2">
          <h4 class="panel-title">
          <span class="title"
            >Consulta de Tipo Desconto.</span
          >
          <br />
          <span class="navigation">Tipo Desconto > Consulta</span>
        </h4>
      </div>
    </div><!--row-->
  </div><!--card-header-->

  <div class="card-body">
    <div class="row">
      <DataTable
        :value="tipoDescontoList"
        :paginator="true"
        :rows="10"
        class="p-datatable-responsive"
        :autoLayout="true"
      >
        <Column headerStyle="width: 8em" bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-pencil"
              style="margin-right: .5em"
              @click="detail(slotProps.data.id)"
            ></Button>
            <Button
              type="button"
              icon="pi pi-trash"
              @click="confirmRemove(slotProps.data.id)"
            ></Button>
          </template>
        </Column>
        <Column field="nome" header="Nome"></Column>
      </DataTable>
    </div><!--row-->
    <hr />

    <div class="row">
      <span class="p-fluid mr-2">
        <router-link to="/tipoDescontoCadastro">
          <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
        </router-link>
      </span>
    </div>
  </div><!--card-body-->
    <Dialog header="Aviso" :visible.sync="display" :style="{width: '30vw'}" :modal="true">
      Confirmar a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
        <Button
          label="Não"
          icon="pi pi-times"
          @click="close"
          title="Não"
          class="p-button-secondary"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import tipoDescontoService from '../services/obras/tipo.desconto.service';

export default {
  name: 'TipoDescontoConsulta',
  data() {
    return{
      display: false,
      search: false,
      filtro: "",
      tipoDescontoList: [],
      id: null,
      currentUser: null
    }
  },
  created(){
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods:{
    clear(){
      this.pesquisar();
    },
    pesquisar(){
      this.search = true;
      tipoDescontoService.findTipoDescontoByFiltro(
        this.currentUser.usuario.idCliente,
        this.filtro
      ).then(
        tipoDesconto=>{
          this.tipoDescontoList = tipoDesconto.data;
        },
        error=>{
          let errorMessage = "Houve um problema ao listar Tipo Desconto!";
          if(error.response){
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(id){
      this.$router.push({name: "TipoDescontoCadastro", params: {idTipoDesconto: id} });
    },
    confirmRemove(id){
      this.id = id;
      this.display = true;
    },
    close(){
      this.id = null;
      this.display = false;
    },
    remove(){
      tipoDescontoService.removeTipoDesconto(this.id).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Tipo Desconto removido com sucesso"
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.display = false;
          }, 250);
          },
          error => {
          let errorMessage = "Houve um problema ao remover o Tipo Desconto!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      )
    }
  }
}
</script>